import { MenuItem } from "@material-ui/core";
import { noop } from "@utils/Functions";
import { AxiosResponse } from "axios";
import React from "react";

export interface IEnumStringHook<TKey extends string | number | symbol> {
    data?: Record<TKey, string>
    handleResponse: (response: AxiosResponse<Record<TKey, string>>) => void
    createOptions: () => JSX.Element[]
    load: (loadFunction: () => Promise<AxiosResponse<Record<TKey, string>>>) => void
}

export function useEnumString<TKey extends string | number | symbol>(initialData?: Record<TKey, string>) : IEnumStringHook<TKey> {
    const [data, setData] = React.useState<Record<TKey, string> | undefined>(initialData);

    const handleResponse = React.useCallback((response: AxiosResponse<Record<TKey, string>>) => {
        setData(response.data);
    }, []);

    const load = React.useCallback((loadFunction: () => Promise<AxiosResponse<Record<TKey, string>>>) => {
        loadFunction()
            .then(handleResponse)
            .catch(noop);
    }, [handleResponse]);

    const createOptions = React.useCallback(() => {
        if (data !== undefined) {
            return Object.keys(data).map(k => {
                const key = k as TKey;
                return <MenuItem key={k} value={data[key]}>{data[key]}</MenuItem>
            });
        }

        return [];
    }, [data]);

    return React.useMemo(() => ({
        data, handleResponse, createOptions, load
    }), [data, handleResponse, createOptions, load]);
}